import type { IApp } from '@bprotsyk/aso-core';

export const isPdlOfferwallListApp = (app: IApp): boolean => {
  if (!app?.id || app.id === 0 || !app.name) return false;
  if ((app as any).playStoreMonitoring?.watchOnly === true) return false;
  return (app as any).appMode !== 'webview';
};
